import HomePage from "@/main/components/features/home/HomePage"

const Home = () => {
	return <HomePage />
}

export default Home
